import {
  IAnalyticsEventBase,
  IOptionalAnalyticsProperties,
  IRequiredAnalyticsProperties,
} from '../../types';

export type IAnalyticsEventErrorProperties = IRequiredAnalyticsProperties<
  'object_name' | 'object_type'
> &
  IOptionalAnalyticsProperties<'context'>;

export type IAnalyticsEventError = IAnalyticsEventBase &
  IAnalyticsEventErrorProperties;

export enum AnalyticsErrorContext {
  ExecuteReport = 'Execute Report',
  FilterWidget = 'Filter Widget',
  InviteUsers = 'Invite Users',
  SaveGroup = 'Save Group',
  SaveRole = 'Save Role',
  SaveWorkspace = 'Save Workspace',
  DuplicateDashboard = 'Duplicate Dashboard',
  DuplicateDashboardReport = 'Duplicate Dashboard Report',
  ExplainReportWithAi = 'Explain Report With AI',
  ExplainDashboardWithAi = 'Explain Dashboard With AI',
}

export type IAnalyticsErrorArgument = {
  message: string;
  context?: AnalyticsErrorContext;
};
